import script from "./InsertSVG.vue?vue&type=script&setup=true&lang=js"
export * from "./InsertSVG.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__